import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WebProviderService } from '../web/web.provider.service';
import { assert } from 'src/app/utils/assert.util';

@Injectable({
  providedIn: 'root'
})
export class ItemDescriptionProviderService {
  private webProvider = inject(WebProviderService);
  private readonly baseURL = environment.apiURL;
  private get attributeURL() {
    return '/api/Items';
  }

  /**
   * The B2B add-to-cart description for an item. The API is the single source of truth for this
   * format (ADO #8976) — it used to be built in checkout.service.ts, which meant the same format
   * existed in two languages and could drift.
   *
   * Returned untruncated; the caller applies B2B's 50-character limit.
   * responseType must be 'text' — the endpoint serves text/plain, not JSON.
   *
   * `retailerIframeID` is required and must be non-null. Passing an undefined header value throws
   * inside Angular's HttpHeaders ("Cannot read properties of undefined (reading 'toString')"),
   * which is what broke add-to-cart on the B2B path — a B2B session has no iframe key in its
   * payload and must resolve it through CustomerService first.
   */
  async get(itemNumber: string, retailerIframeID: string) {
    assert(retailerIframeID, 'No retailer iframe ID for the item description lookup');
    const description = await this.webProvider.get<string>(
      `${this.baseURL}${this.attributeURL}/${encodeURIComponent(itemNumber)}/Description`,
      { headers: { apiKey: retailerIframeID }, responseType: 'text' }
    );
    assert(description, 'Failed to get item description');
    return description;
  }
}
